// src/utils/precalentarCheckout.js
//
// PRECALENTAMIENTO DEL CHECKOUT. `/contratar` llama a esto al montarse para que el arranque en
// frío de `createCheckoutSessionHttp` (11–19 s, medido el 28-sep-2026: los 9 checkouts desde el
// 16-sep arrancaron desde cero instancias) ocurra mientras la persona rellena el formulario, y
// no después de pulsar «Continuar al pago».
//
// El servidor responde 204 a `GET ?warm=1` ANTES de verificar el token, leer el secreto, tocar
// Stripe o Firestore (`functions/createCheckoutSessionHttp.js`, bloque WARM-UP).
//
// `mode: 'no-cors'`: un GET simple sin cabeceras propias no dispara preflight, y la respuesta
// no hace falta leerla — basta con que llegue al contenedor. Nunca lanza: si falla, la persona
// no pierde nada; el checkout funciona igual, sólo que en frío.
//
// Sin imports a propósito: la suite de `functions/` la carga y la ejercita
// (`functions/__tests__/contratarCaminoAStripe.jest.test.js`).

export function urlDePrecalentamiento(url) {
  if (typeof url !== 'string' || !url) return null;
  return url + (url.includes('?') ? '&' : '?') + 'warm=1';
}

export function precalentarCheckout(url, fetchImpl) {
  const destino = urlDePrecalentamiento(url);
  if (!destino || typeof fetchImpl !== 'function') return false;
  try {
    const p = fetchImpl(destino, { method: 'GET', mode: 'no-cors', cache: 'no-store', credentials: 'omit' });
    if (p && typeof p.catch === 'function') p.catch(() => {});
    return true;
  } catch {
    return false;
  }
}
